// モフトレチェック/月選択画面.
import * as React from 'react';
import * as Header from '../constants/Header';
import { TUGTable, BalanceTable } from '../constants/MoffCheck';
import UserDetail, { DummyUserDetail } from './common/UserDetail';
import { JS_VOID } from '../utils/commonUtil';
import { MDate, getFirstEndDay } from '../utils/dateUtil';
import * as _ from 'lodash';
import * as Enumerable from 'linq';
import '../css/press.css';
import '../css/month_select.css';
import MoffCheckModule from '../utils/MoffCheckModule';

interface MoffCheckSelectMonthProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  moffCheckActions: any;
  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;

  moffCheck: any;
}

interface MoffCheckSelectMonthState {
  date: MDate;
  // 長期変化.
  locomoState: number;
}

/**
 * 月選択画面のクラス.
 *
 * @export
 * @class MoffCheckSelectMonth
 * @extends {React.Component<MoffCheckSelectMonthProps, MoffCheckSelectMonthState>}
 */
export default class MoffCheckSelectMonth extends React.Component<
  MoffCheckSelectMonthProps, MoffCheckSelectMonthState> {
  private cachedUser: any;
  private userId: string;

  private yearSelected: string;
  // 0埋め2桁.
  private monthSelected: string;
  private mDate: MDate;

  componentWillMount() {
    document.title = 'モフトレチェック';  

    this.props.headerActions.setPage(Header.MOFF_CHECK_SELECT_MONTH);

    this.mDate = new MDate();
    this.refresh();

    // URLのパラメータ.
    this.userId = this.props.match.params.userId;
    this.runAPI();
  }

  /**
   *  左をクリックしたときの処理.
   *
   * @memberof MoffCheckSelectMonth
   */
  minusMonthly = (yearSelected: string, monthSelected: string) => {
    // 先月.
    this.mDate.setPreMonth();
    this.refresh();
    this.runAPI();
  }

  /**
   * 右をクリックしたときの処理.
   *
   * @memberof MoffCheckSelectMonth
   */
  plusMonthly = (yearSelected: string, monthSelected: string) => {
    // 次の月.
    this.mDate.setNextMonth();
    this.refresh();
    this.runAPI();
  }

  /**
   *  範囲内でAPIを叩く.
   *
   * @memberof MoffCheckSelectMonth
   */
  runAPI() {
    // 最初の日と最後の日を返す.
    const [startDate, endDate] = getFirstEndDay(this.yearSelected, this.monthSelected);

    // API呼び出し.
    this.props.moffCheckActions.getMoffCheckData(this.userId, startDate, endDate);
  }

  /**
   * リフレッシュ.
   *
   * @memberof MoffCheckSelectMonth
   */
  refresh = () => {
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.setState({date: this.mDate});
  }

  /**
   * ボタンたちを描画.
   *
   * @returns {JSX.Element}
   * @memberof MoffCheckSelectMonth
   */
  renderDispYearMonth(): JSX.Element {
    let result: any = this.props.moffCheck.result;
    let tugItems: TUGTable[] = result.tug.Items;
    let balanceItems: BalanceTable[] = result.balance.Items;

    let tugDic = MoffCheckModule.convertTUG(tugItems);
    let balanceDic = MoffCheckModule.convertBalance(balanceItems);

    // yyyy-mm配列.
    let tugArr = Object.keys(tugDic);
    // yyyy-mm配列.
    let balanceArr = Object.keys(balanceDic);

    // 複数の配列の和集合（重複を除いた全ての値）を取得する.
    // TUGと開眼片足立ち立位の片方でもあれば出す.
    const dispYearMonth = _.union(tugArr, balanceArr);

    let cnt = dispYearMonth.length;
    if (cnt === 0) {
      return (<p>データがありません。</p>);
    }

    return (
      <div className="button_image">
      {
        // すでに数が0のは選定済み.
        Enumerable.from(dispYearMonth)
        // yyyy-mmの日付順に並び替え.
        .orderBy(item => item)
        .select<JSX.Element>((element: string, index: number) => {
          return<span key={`pressSelectButton${index}`}>
            <a
              href={`/moff_check/${this.userId}/${element}`}
              className={index % 2 === 0 ? 'month_grey' : 'month_white'}
              target="_blank"
            >
              <span key={`pressSelectYearMonth${index}`}>{element}</span>
            </a>
          </span>;
        }).toArray()
      }
      </div>
    );
  }

  /**
   * 描画.
   *
   * @returns
   * @memberof MoffCheckSelectMonth
   */
  render() {
    return (
      <div>
        <style type="text/css">
          {'a:link, a:visited, a:active {color:#000;text-decoration:none;}'}
        </style>
        {
          (() => {
            if (this.props.moffCheck.Loaded) {
              // キャッシュさせておく.
              if (this.props.moffCheck.result.user) {
                this.cachedUser = this.props.moffCheck.result.user;
              }

              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        <article className="report">
          {(this.props.moffCheck.Loaded || this.cachedUser) ? 
            // ロードしたUserを表示
            // ロードした利用者の詳細
            <UserDetail user={this.props.moffCheck.result.user || this.cachedUser} /> 
            :
            <DummyUserDetail />
          }
          <section id="sec02">
            <h2 className="ttlStyle01">モフトレチェックを表示する月を選んで下さい</h2>
            <div className="inner">
              <div className="calendarHeader">
                <div className="dateArea">
                  <div className="date">
                    {this.yearSelected}<span className="year">年</span>{this.monthSelected}<span>月までの1年分を表示</span>
                  </div>
                  <div className="btn left">
                    <a href={JS_VOID} onClick={event => this.minusMonthly(this.yearSelected, this.monthSelected)} />
                  </div>
                  <div className="btn right">
                    <a href={JS_VOID} onClick={event => this.plusMonthly(this.yearSelected, this.monthSelected)} />
                  </div>
                </div>
              </div>
              { // データ数でのif
                (() => {
                  if (this.props.moffCheck.Loading) {
                    return <div><p>読み込み中</p></div>;
                  } else if (this.props.moffCheck.Loaded) {
                    return this.renderDispYearMonth();
                  } else {
                    return (null);
                  }
                })()
              }
            </div>
          </section>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MoffCheckSelectMonth.tsx